// BanLevelSelector.jsx
import React, { useEffect, useState } from 'react';
import { FormControl, Select, MenuItem, CircularProgress } from '@mui/material';
import { decreaseSusLevel, increaseSusLevel } from 'services/players';

export function BanLevelSelector({ userId, initialLevel = 0, onBanAction }) {
  const [level, setLevel] = useState(initialLevel);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLevel(initialLevel);
  }, [initialLevel]);

  const handleSelect = async (event) => {
    const newLevel = event.target.value;
    if (newLevel === level) return;
    setLoading(true);

    if (newLevel > level) {
      const res = await increaseSusLevel(userId);
      if (res.status === 200 || res.status === 201) {
        console.log(`Suspicious level increased for user ${userId}`);
        // setLevel(newLevel);
        onBanAction();
      } else {
        console.error(`Failed to increase suspicious level for user ${userId}`);
      }
    } else {
      const res = await decreaseSusLevel(userId);
      if (res.status === 200 || res.status === 201) {
        console.log(`Suspicious level decreased for user ${userId}`);
        // setLevel(newLevel);
        setLoading(false);
        onBanAction();
      } else {
        console.error(`Failed to increase suspicious level for user ${userId}`);
        setLoading(false);
      }
    }
  };

  return (
    <FormControl size='small' fullWidth disabled={loading}>
      <Select
        labelId={`ban-level-label-${userId}`}
        id={`ban-level-select-${userId}`}
        value={level}
        onChange={handleSelect}
        IconComponent={loading ? () => <CircularProgress size={20} /> : undefined}
        sx={{
          p: '6px',
          bgcolor: level === 0 ? '#80EF80' : level === 1 ? '#FFFF00' : '#f44336',
          color: '#000', // ← text color for the displayed value
          fontWeight: 'bold',
          textTransform: 'uppercase',
          '& .MuiSelect-select': {
            color: '#000' // make sure the inner input also inherits it
          }
        }}
      >
        <MenuItem value={0} disabled={level === 2 ? true : false}>
          Normal
        </MenuItem>
        <MenuItem value={1}>Warn</MenuItem>
        <MenuItem value={2} disabled={level === 0 ? true : false}>
          Threat
        </MenuItem>
      </Select>
    </FormControl>
  );
}
